import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Case.css"; 
import img1 from "../Images/case1.png"; 
import img2 from "../Images/case2.png"; 
import State from '../Components/State'

const Case = () => {
  return (
    <>
    <div className="container-xxl py-5 hero-header1">
      <div className="container my-5 py-5 px-lg-5">
        <div className="row g-5 py-5">
          <div className="col-12 text-center">
            <h1 className="text-white animated slideInDown">Case-Studies</h1>
            <hr className="bg-white mx-auto mt-0" style={{ width: "90px" }} />
          </div>
        </div>
      </div>
    </div>

    <Container className="py-5">
      <Row className="align-items-center">
        {/* First Column (Heading, Text, Button) */}
        <Col md={5} xs={12} className="text-col" id="case1">
          <h2>Our Case Study</h2>
          <p>We provide the best solutions for your business with modern strategies and advanced technologies.</p>
          {/* <Button className=" case-btn">Get Started</Button> */}

          <Link
             to="/get-started#payment-section"
            className="case-btn text-decoration-none rounded"
            
          >
            Get Started
          </Link>
        </Col>

        {/* Second Column (Two Images) */}
        <Col md={7} xs={12} className="image-col">
          <div className="image-container">
            <img src={img1} alt="Image 1" className="img1" />
            <img src={img2} alt="Image 2" className="img2" />
          </div>
        </Col>
      </Row>
    </Container>
    <State />
    </>
  );
};

export default Case;
